<template>
    <div>
        <div class="topbar-one">
            <div class="container">
                <div class="topbar-one__left">
                    <a href="#" style="padding-top: 3px;">zhyldyzacademy@protonmail.com</a>
                    <a href="#" style="padding-top: 3px;">+996 555 94 95 01</a>
                </div><!-- /.topbar-one__left -->
                <div v-if="!loggedIn.title" class="topbar-one__right">
                    <a @click="openLogin" style="color: #fff; padding-top: 3px;" >{{$t('login')}}</a>
                    <a @click="openRegister" style="color: #fff; padding-top: 3px;">{{$t('register')}}</a>
                </div>
                <div v-if="loggedIn.title" class="topbar-one__right">
                    <v-menu
                    open-on-hover
                    bottom
                    offset-y
                    origin="center center"
                    transition="scale-transition"
                    style="z-index: 9999; min-width: 200px;"
                    >
                        <template v-slot:activator="{ on, attrs }" >
                            <a style="color: #fff;" v-bind="attrs" v-on="on"><v-icon class="topbar-one__right__icon"  color="#fff">mdi-account-circle</v-icon> {{loggedIn.title}}</a> 
                        </template>
                        <v-list style="padding: 0px 0px;border-radius: 0px;">
                            <v-list-item class="list" style="padding: 5px 16px; min-height: 30px;cursor: pointer;">
                                <v-list-item-title class="list__title" style="font-size: 16px;">{{$t('profile')}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="list" style="padding: 5px 16px; min-height: 30px;cursor: pointer;">
                                <v-list-item-title class="list__title" style="font-size: 16px;">{{$t('mycourse')}}</v-list-item-title>
                            </v-list-item>
                            <!--<v-list-item class="list" style="padding: 5px 16px; min-height: 30px;cursor: pointer;">
                                <v-list-item-title class="list__title" style="font-size: 16px;">{{$t('myreviews')}}</v-list-item-title>
                            </v-list-item>-->
                            <v-list-item class="list" style="padding: 5px 16px; min-height: 30px;cursor: pointer;" @click="logOut">
                                <v-list-item-title class="list__title" style="font-size: 16px;">{{$t('logout')}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div><!-- /.topbar-one__right -->

                <select class="" id="lang2" v-model="$i18n.locale"  style="border: 1px inset #8A8FA6; padding: 3px 10px;border-radius: 12px;height: 40px;color: #fff;">
                  <option value="kg">🇰🇬 KG</option>
                  <option value="en">🇺🇸 En</option>
                </select>
            </div><!-- /.container -->
        </div>
        <!-- Login Dialog -->
    <v-dialog
      v-model="loginDialog"
      width="500"
      style="z-index: 9999;"
    >
      <v-card>
        <v-card-title class="text-h5" style="background: #022c46; color: #fff;">
          Sign in to Zhyldyz Academy
        </v-card-title>

        <v-card-text>
            <v-form ref="loginForm" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" style="padding: 30px 12px 0px 12px;">
                        <v-text-field v-model="email" :rules="loginEmailRules" type="email" label="Электронная почта" required solo append-icon="mdi-account"></v-text-field>
                    </v-col>
                    <v-col cols="12" style="padding: 0px 12px 12px 12px">
                        <v-text-field 
                        v-model="password" 
                        :append-icon="show1?'mdi-eye':'mdi-eye-off'" 
                        :rules="[rules.required, rules.min]" 
                        :type="show1 ? 'text' : 'password'" 
                        name="input-10-1" label="Пароль" 
                        hint="Как минимум 6 символов" 
                        counter 
                        solo
                        @click:append="show1 = !show1"
                        ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" align="end">
                        <v-btn :disabled="!valid" color="#f16101" @click="loginBtn" style="color:#fff;"> Войти </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="registerDialog"
      width="500"
      style="z-index: 9999;"
    >
      <v-card>
        <v-card-title class="text-h5" style="background: #022c46; color: #fff;">
          {{$t('registert')}}
        </v-card-title>

        <v-card-text>
            <v-form ref="loginForm" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" sm="6" md="6" style="padding: 30px 12px 0px 12px;">
                        <v-text-field v-model="signupForm.firstName" :rules="[rules.required]" label="Имя" maxlength="20" required solo append-icon="mdi-account-check"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" style="padding: 30px 12px 0px 12px;">
                        <v-text-field v-model="signupForm.lastName" :rules="[rules.required]" label="Фамилия" maxlength="20" required solo append-icon="mdi-account-box-outline"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select v-model="signupForm.level" :items="levels" item-text="name" item-value="name" :rules="[rules.required]" label="Ваш уровень" required solo append-icon="mdi-certificate"></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="signupForm.email" :rules="emailRules" label="Электронная почта" required solo append-icon="mdi-email-outline"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" lg="6" sm="12">
                        <v-text-field 
                        v-model="signupForm.password" 
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required, rules.min]" 
                        :type="show1 ? 'text' : 'password'" 
                        name="input-10-1" 
                        label="Пароль" 
                        hint="Как минимум 6 символов" 
                        counter
                        solo
                        @click:append="show1 = !show1"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" lg="6" sm="12">
                        <v-text-field 
                        block 
                        v-model="verify" 
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[ rules.required, passwordMatch ]" 
                        :type="show1 ? 'text' : 'password'" 
                        name="input-10-1" 
                        label="Подтвердите пароль" 
                        counter 
                        solo
                        @click:append="show1 = !show1"
                        ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex" cols="6" sm="12" xsm="12" md="3" lg="4" align-end>
                        <v-btn :disabled="!valid" color="success" @click="register">{{$t('register')}}</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Login Dialog -->
    </div>
</template>
<script>
import '../../assets/css/style.css'
import { mapActions  } from 'vuex';
import {userService} from '../../_services/user.service';
import * as firebase from '@/firebase';
export default {
    name: "TopHeader",
    data: () => ({
        isLoading: false,
        isShow: false,
        loginDialog: false,
        valid: true,
        show1: false,
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        verify: "",
        username: "",
        rules: {
            required: value => !!value || "Обязательно",
            min: v => (v && v.length >= 6) || "Min 6 characters"
        },
        loginEmailRules: [
            v => !!v || "Обязательно",
            v => /.+@.+\..+/.test(v) || "Электронная почта должна быть действительной"
         ],
         emailRules: [
            v => !!v || "Обязательно",
            v => /.+@.+\..+/.test(v) || "Электронная почта должна быть действительной"
         ],
         items: [
            { title: 'Click Me' },
            { title: 'Click Me' },
            { title: 'Click Me' },
            { title: 'Click Me 2' },
        ],
         signupForm: {
            name: '',
            title: '',
            email: '',
            password: '',
            firstName: "",
            lastName: "",
            level: ""
         },
         levels: [
            {
                name: "Beginner"
            },
            {
                name: "Elementary"
            },
            {
                name: "Pre-Intermediate"
            }
         ],
         registerDialog: false,
    }),
    computed: {
      passwordMatch() {
         return () => this.signupForm.password === this.verify || "Password must match";
      },
      loggedIn () {
         return this.$store.state.account.user;
      },
   },
    mounted() {},
    methods :{
      openLogin() {
          this.loginDialog = true;
      },
      openRegister() {
          this.registerDialog = true;
      },
      ...mapActions('account', [ 'login', 'logout' ,'signup']),
      register() {
            this.signup({
               email: this.signupForm.email,
               password: this.signupForm.password,
               name: this.signupForm.firstName,
               title: this.signupForm.firstName +' '+ this.signupForm.lastName,
               level: this.signupForm.level
            });
            this.registerDialog = false;
            this.$alert(
                "Сиз катталдыңыз, 3 күн ичинде кабыл алынасыз!",
                "Success",
                "success"
                ).then(() => console.log("Closed"));
            localStorage.setItem('user', JSON.stringify({}));

      },
      loginBtn() {
            const { email, password } = this;
            if (email && password) {
               this.login({ email, password });
               this.loginDialog = false;
                //this.isLoading = true;
                // setTimeout(()=>{
                //     this.isLoading = false;
                // },300)
                if(this.loggedIn.role === 'ADMIN'){
                   this.$router.push({ path: '/admin-page/tests' });
                }
               
            }
      },
      async getPosts() {
          this.isLoading = true;
          this.events = await firebase.postsCollection.get()
            .then((snapshot) => {
              snapshot.forEach((el) => {
                  this.posts.push({...el.data()})
              });
            })
            this.isLoading = false;
      },
      //firebase.usersCollection.doc(res.user.uid).get().then(snapshot => console.log(snapshot.data()))
      reset() {
         this.$refs.form.reset();
      },
      resetValidation() {
         this.$refs.form.resetValidation();
      },
      logOut() {
         userService.logout();
      },
      toElem () {
         if(!this.loggedIn.title){
            this.loginModal = true;
         }
         else if(this.loggedIn.role == 'STUDENT') {
            this.$router.push({ name: 'elementary' });
         }
         else if(this.loggedIn.role == 'ADMIN') {
            this.$router.push({ path: '/admin-page/elementary' });
         }
      },
      toBeginer() {
         this.$router.push({ path: '/beginner' });
      }
    }
}
</script>
<style lang="scss">
.swal2-container .swal2-center .swal2-shown {
    z-index: 999 !important;
}
.list {
    &__title {
        color: #022c46;
    }
}

.list:hover {
    background: #9b9c9c;
}
#lang2 {
    display: none;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
    .topbar-one__left {
        display: none;
    }
    .topbar-one__right {
        float: right;
        padding: 10px 0px;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: start;
    }
    .topbar-one__right a {
        float: left;
        font-size: 16px;
    }
    .topbar-one__right__icon {
        font-size: 30px !important;
    }
    .topbar-one {
        position: fixed;
    }
    #lang2 {
        position: absolute;
        top: 10px;
        right: 10px;
        display: block;
        border-color: #fff !important;
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content: end;
        width:min-content;
    }
}
</style>